import type { Cards, TaskList } from '../../../../common/types.tsx';
import {
	PLAN_CREATE_MORE_WORK_ITEMS_TASK,
	PLAN_BRING_IN_THE_TEAM_TASK,
	PLAN_CONFIRM_SCOPE_AND_SETTINGS_TASK,
	PLAN_CONNECT_RELATED_WORK_TASK,
	PLAN_ADJUST_DETAILS_TASK,
	PLAN_SHARE_YOUR_PLAN_WITH_THE_WORLD_TASK,
} from '../../../../common/constants.tsx';
import { Feature } from '../tailored-onboarding/constants.tsx';
import { messages } from './messages.tsx';

export const Permissions = {
	hasPlanEditPermission: 'permissions.hasPlanEditPermission',
	hasPlanInvitePermission: 'permissions.hasPlanInvitePermission',
} as const;

export const PLAN_TASK_LIST: TaskList = Object.freeze({
	root: {
		title: messages.rootTitle,
		items: [
			PLAN_CREATE_MORE_WORK_ITEMS_TASK,
			PLAN_BRING_IN_THE_TEAM_TASK,
			PLAN_CONFIRM_SCOPE_AND_SETTINGS_TASK,
			PLAN_CONNECT_RELATED_WORK_TASK,
			PLAN_ADJUST_DETAILS_TASK,
			PLAN_SHARE_YOUR_PLAN_WITH_THE_WORLD_TASK,
		],
	},
});

export const PLAN_TASK_VARIANTS: Cards = {
	[PLAN_CREATE_MORE_WORK_ITEMS_TASK]: {
		position: { default: 0 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Permissions.hasPlanEditPermission],
					value: true,
				},
			],
		},
	},
	[PLAN_BRING_IN_THE_TEAM_TASK]: {
		position: { default: 10 },
		visibility: {
			default: true,
		},
	},
	[PLAN_CONFIRM_SCOPE_AND_SETTINGS_TASK]: {
		position: { default: 20 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Permissions.hasPlanEditPermission],
					value: true,
				},
			],
		},
	},
	[PLAN_CONNECT_RELATED_WORK_TASK]: {
		position: { default: 30 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasPlanDependencies],
					value: true,
				},
			],
		},
	},
	[PLAN_ADJUST_DETAILS_TASK]: {
		position: { default: 40 },
		visibility: {
			default: true,
		},
	},
	[PLAN_SHARE_YOUR_PLAN_WITH_THE_WORLD_TASK]: {
		position: { default: 50 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Permissions.hasPlanInvitePermission],
					value: true,
				},
			],
		},
	},
};
